module.exports = __webpack_public_path__ + "static/media/left_bias.29b0291b.png";